import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { createElement } from "@wordpress/element";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * WordPress dependencies
 */
import { forwardRef } from '@wordpress/element';
import { isRTL } from '@wordpress/i18n';
/**
 * Internal dependencies
 */

import { POSITIONS } from './utils';
import { TooltipWrapper, Tooltip, LabelText } from './styles/resize-tooltip.styles';
var CORNER_OFFSET = 4;
var CURSOR_OFFSET_TOP = CORNER_OFFSET * 2.5;

function Label(_ref, ref) {
  var label = _ref.label,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? POSITIONS.corner : _ref$position,
      _ref$zIndex = _ref.zIndex,
      zIndex = _ref$zIndex === void 0 ? 1000 : _ref$zIndex,
      props = _objectWithoutProperties(_ref, ["label", "position", "zIndex"]);

  var showLabel = !!label;
  var isBottom = position === POSITIONS.bottom;
  var isCorner = position === POSITIONS.corner;
  if (!showLabel) return null;
  var style = {
    opacity: showLabel ? 1 : null,
    zIndex: zIndex
  };
  var labelStyle = {};

  if (isBottom) {
    style = _objectSpread(_objectSpread({}, style), {}, {
      position: 'absolute',
      bottom: CURSOR_OFFSET_TOP * -1,
      left: '50%',
      transform: 'translate(-50%, 0)'
    });
    labelStyle = {
      transform: "translate(0, 100%)"
    };
  }

  if (isCorner) {
    style = _objectSpread(_objectSpread({}, style), {}, {
      position: 'absolute',
      top: CORNER_OFFSET,
      right: isRTL() ? null : CORNER_OFFSET,
      left: isRTL() ? CORNER_OFFSET : null
    });
  }

  return createElement(TooltipWrapper, _extends({
    "aria-hidden": "true",
    className: "components-resizable-tooltip__tooltip-wrapper",
    isActive: showLabel,
    ref: ref,
    style: style
  }, props), createElement(Tooltip, {
    className: "components-resizable-tooltip__tooltip",
    style: labelStyle
  }, createElement(LabelText, {
    as: "span"
  }, label)));
}

var ForwardedComponent = forwardRef(Label);
export default ForwardedComponent;
//# sourceMappingURL=label.js.map